import script from "./TabContent.vue?vue&type=script&setup=true&lang=js"
export * from "./TabContent.vue?vue&type=script&setup=true&lang=js"

import "./TabContent.vue?vue&type=style&index=0&id=3a92cd81&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Veverica\\Documents\\projekti\\btc-prop\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a92cd81"]])

export default __exports__